export default "__VITE_ASSET__B1RV0gBJ__"